import { Directive, ElementRef, Input, OnChanges, OnInit, Renderer2, SimpleChange, SimpleChanges } from '@angular/core';
import { ImagePlaceholderDirective, isNullOrUndefined, SafeUrlPipe } from '@uzurv/core';

import { Driver } from '../../models';
import { DriverService } from '../../services';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'img[dotsDriver]',
    host: {
        '(error)': 'onError()',
        '(load)': 'onLoad()',
        '[src]': 'src'
    },
    standalone: true
})
export class DriverProfilePictureDirective extends ImagePlaceholderDirective implements OnInit, OnChanges {
  @Input()
  dotsDriver: Driver;

  constructor(protected renderer: Renderer2, protected hostElement: ElementRef, protected driverService: DriverService, protected safeUrlPipe: SafeUrlPipe) {
    super(renderer, hostElement);
  }

  ngOnInit() {
    this.src = this.placeholder;
    this.fetchProfilePicture();
  }

  ngOnChanges(changes: SimpleChanges) {
    const dotsDriverChange: SimpleChange = changes.dotsDriver;
    if (dotsDriverChange) {
      if (isNullOrUndefined(dotsDriverChange.currentValue)) {
        this.src = this.placeholder;
        return;
      }

      if (!dotsDriverChange.currentValue.equals(dotsDriverChange.previousValue)) {
        this.fetchProfilePicture();
      }
    } else {
      this.src = this.placeholder;
    }
  }

  refresh() {
    this.fetchProfilePicture();
  }

  onError() {
    super.onError();
  }

  onLoad() {
    super.onLoad();
  }

  private fetchProfilePicture() {
    if (isNullOrUndefined(this.dotsDriver) || isNullOrUndefined(this.dotsDriver.id)) {
      return;
    }

    this.driverService.getProfilePictureForDriver(this.dotsDriver.id).subscribe(
      fileData => {
        if (!isNullOrUndefined(fileData)) {
          this.src = this.safeUrlPipe.transform(fileData.getDataURLString());
        }
      },
      err => {
        this.src = this.placeholder;
      }
    );
  }
}
